import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./Separator.module.css";

interface Props {
    class?: string;
    vertical?: boolean;
}

export default function Separator({
    class: cssClass,
    vertical = false
}: Props) {
    return <div class={classname(styles.separator, cssClass, { [styles.vertical]: vertical })}/>;
}
